import paginationDotOuterLayer from '@assets/intro-screen/pagination-dot-outer-layer.svg'
import { BuildGradientStyle } from '@utils/buildGradientStyle'
import React from 'react'

type PaginationDotSection = {
    pages: number
    currentPage: number
    className: string
    activeLayerStyle: BuildGradientStyle
}

type PaginationDot = {
    active: boolean
    activeLayerStyle: BuildGradientStyle
}

const PaginationDot: React.FC<PaginationDot> = (props) => {
    const { active, activeLayerStyle } = props

    return (
        <div className="relative">
            <img src={paginationDotOuterLayer} width={active ? 24 : 16} height={active ? 24 : 16} />
            {active && (
                <div
                    className="absolute left-[5px] top-[5px] h-[14px] w-[14px] rounded-[10px]"
                    style={activeLayerStyle}
                ></div>
            )}
        </div>
    )
}

export const PaginationSection: React.FC<PaginationDotSection> = (props) => {
    const { className, pages, currentPage, activeLayerStyle } = props

    return (
        <div className={className}>
            {Array.from({ length: pages + 1 }, (_, i) => (
                <PaginationDot key={i} active={currentPage === i} activeLayerStyle={activeLayerStyle} />
            ))}
        </div>
    )
}
